import apiClient, {baseUrl} from "../services/axios";
import {alert} from 'devextreme/ui/dialog';
import LoaderService from "./LoaderService";


const DownloadService = {
    generatePropertyPurchaseSaleReport: function (id, pdf) {
        const params = new URLSearchParams({
            externalId: id,
            pdf: pdf
        });
        return this.generalDownloadFile('/Property/GeneratePropertyPurchaseSaleReport?' + params, id);
    },
    generalDownloadFile: function (urlWithParams, id) {
        if (id === '') {
            return alert('Id of the object you are trying to download is not supplied in the data set.', 'Warning!');
        }
        LoaderService.setData(true);
        apiClient
            .get(urlWithParams)
            .then(response => {
                if (response) {
                    try {
                        let resp = JSON.parse(response.data);
                        LoaderService.setData(false);
                        if (resp[0].response) {
                            let path = baseUrl() + resp[0]['message'];
                            let win = window.open(path, '_blank');
                            win.focus();
                        } else {
                            return alert(resp[0].message + '<br /><br /><i>[TIP: Most errors in file downloads are caused by popup blockers.' +
                                '<br />Kindly configure your browser to allow popups if errors persist.</i>', 'Warning!');
                        }
                    } catch (e) {
                        LoaderService.setData(false);
                        return alert(response.data, 'Error!');
                    }
                }
            })
            .catch(err => {
                LoaderService.setData(false);
                console.log(err);
            });
    },
}
export default DownloadService;